// Components
import Comments from 'components/Comments';
import ActiveCriteria from './sections/ActiveCriteria';
import Attributes from './sections/Attributes';
import GeneralInfo from './sections/GeneralInfo';
import Properties from './sections/Properties';
import ReservationPeriod from './sections/ReservationPeriod';
import ReservationRange from './sections/ReservationRange';
import TimeSlot from './sections/TimeSlot';
import type { IProps } from './sections/sections.interface';

const TimeRule = ({ timeRule, ...props }: IProps) => {
  if (!timeRule) return null;
  const isStandard = !timeRule.timeSlotSelection;

  return (
    <>
      <GeneralInfo {...props} timeRule={timeRule} />
      {isStandard && <ActiveCriteria {...props} timeRule={timeRule} />}
      <ReservationRange {...props} timeRule={timeRule} />
      {isStandard && <Properties {...props} timeRule={timeRule} />}
      {!isStandard && <TimeSlot {...props} timeRule={timeRule} />}
      <Attributes {...props} timeRule={timeRule} />
      <ReservationPeriod {...props} timeRule={timeRule} />
      <Comments
        value={timeRule.description}
        disabled={!props.userIsSuper}
        onChange={(value) => props.onChange({ key: 'description', value })}
      />
    </>
  );
};

export default TimeRule;
